import {useAppSelector} from '../../store'
import {selectSceneByIndex} from '../store/scenesSlice'
import {MAX_SHADOW_REACH} from '../../constants/scene3d'

// Shadow-catcher half-size: sized to the maximum dynamically-fitted shadow
// frustum (`MAX_SHADOW_REACH`) so the catcher always extends across whatever
// region the per-frame shadow-frustum fitter ends up covering — including
// very wide exports (feature graphics) where the visible scene reaches far
// beyond the placement volume. The plane is transparent except where a shadow
// lands, so over-sizing it is free.
const CATCHER_HALF_SIZE = MAX_SHADOW_REACH

/** Shadow catcher plane — sits behind the device back face */
const ShadowCatcher = ({sceneIndex}: {sceneIndex: number}) => {
  const sceneState = useAppSelector(selectSceneByIndex(sceneIndex))
  const {deviceDepth, groundDistance} = sceneState

  return (
    <mesh position={[0, 0, -(deviceDepth / 2) - groundDistance]} receiveShadow>
      {/* Sized off `SCENE_MAX_REACH`, not device dimensions — keeps a usable
          catcher even for very small devices (e.g. AirPods-class), and
          stays in sync with the directional-light shadow-camera frustum. */}
      <planeGeometry args={[CATCHER_HALF_SIZE * 2, CATCHER_HALF_SIZE * 2]} />
      <shadowMaterial opacity={0.35} />
    </mesh>
  )
}

export default ShadowCatcher
